import Button, { ButtonProps } from "shared/Button/Button";
import React from "react";

export interface ButtonPrimaryProps extends ButtonProps {}

const ButtonPrimary: React.FC<ButtonPrimaryProps> = ({
  className = "",
  ...args
}) => {
  return (
    <Button
        className={`ttnc-ButtonPrimary disabled:bg-opacity-90 bg-primary-500 hover:bg-primary-700 dark:bg-primary-400 dark:hover:bg-primary-500 dark:text-slate-900 text-white shadow-xl ${className}`}
      {...args}
    />
  );
};

export default ButtonPrimary;
